import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { InputWrapper } from "@amzn/stencil-react-components/input";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { Button } from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import { Input } from "@amzn/uxm-stencil-react-components/lib/src/stencil/input";
import { getString } from "common/uistringlabels/uiStringUtils";
import { UserUseCaseLearnMoreLink } from "lib/models/userusecase-models";
import React, { FC } from "react";

import { StepActions } from "./StepActions";
import { StepProps } from "./StepProps";

export const AdditionalResourcesStep: FC<StepProps> = ({ formData, onChange, onNext, onBack, onSaveDraft }) => {
  const updateLink = (index: number, field: keyof UserUseCaseLearnMoreLink, value: string) => {
    const updatedLinks = [...formData.learnMoreLinks];
    updatedLinks[index] = { ...updatedLinks[index], [field]: value };
    onChange({ learnMoreLinks: updatedLinks });
  };

  const addLink = () => {
    onChange({ learnMoreLinks: [...formData.learnMoreLinks, { title: "", url: "" }] });
  };

  const removeLink = (index: number) => {
    if (formData.learnMoreLinks.length > 1) {
      onChange({ learnMoreLinks: formData.learnMoreLinks.filter((_: any, i: number) => i !== index) });
    }
  };

  return (
    <Col gridGap="S400">
      <Text fontSize="T400" fontWeight="bold">
        {getString("useCases.contributeForm.additionalResources")}
      </Text>
      <Text fontSize="T200" color="var(--st-dt-color-text-secondary)">
        {getString("useCases.contributeForm.additionalResourcesDescription")}
      </Text>

      {formData.learnMoreLinks.map((link: any, index: number) => (
        <Row key={index} gridGap="S200" alignItems="flex-end">
          <Col flex={1}>
            <InputWrapper
              id={`link-${index}-title`}
              labelText={getString("useCases.contributeForm.linkTitleLabel", { number: String(index + 1) })}
            >
              {(inputProps) => (
                <Input
                  {...inputProps}
                  touchpoint={`use-case-link-${index}-title`}
                  value={link.title}
                  onChange={(e: any) => updateLink(index, "title", e.target.value)}
                  placeholder={getString("useCases.contributeForm.linkTitlePlaceholder")}
                />
              )}
            </InputWrapper>
          </Col>
          <Col flex={2}>
            <InputWrapper id={`link-${index}-url`} labelText={getString("useCases.contributeForm.labelUrl")}>
              {(inputProps) => (
                <Input
                  {...inputProps}
                  touchpoint={`use-case-link-${index}-url`}
                  value={link.url}
                  onChange={(e: any) => updateLink(index, "url", e.target.value)}
                  placeholder={getString("useCases.contributeForm.urlPlaceholder")}
                />
              )}
            </InputWrapper>
          </Col>
          {formData.learnMoreLinks.length > 1 && (
            <Button
              variant={ButtonVariant.Tertiary}
              onClick={() => removeLink(index)}
              touchpoint={`use-case-remove-link-${index}`}
            >
              ✕
            </Button>
          )}
        </Row>
      ))}

      <Button variant={ButtonVariant.Tertiary} onClick={addLink} touchpoint="use-case-add-link">
        {getString("useCases.contributeForm.addLink")}
      </Button>

      <StepActions onBack={onBack} onSaveDraft={onSaveDraft} onNext={onNext} />
    </Col>
  );
};
